import { render, staticRenderFns } from "./DocumentsIterProcesalDetail.vue?vue&type=template&id=1bc371c2&lang=pug&"
import script from "./DocumentsIterProcesalDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentsIterProcesalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports